module.exports = __webpack_public_path__ + "fonts/jj2 bk.368fe124.otf";